import React, { useCallback, useState } from 'react'
import { useParams, useHistory, Redirect } from 'react-router-dom'

import { useItem } from '../hooks'

import Button, { BUTTON_STYLES } from '../../common/components/Button'

import Form, { FORM_MODES } from './Form'

const DetailsBody = ({ item, save, fields, routeName }) => {
  const history = useHistory()
  const [formState, setFormState] = useState(item)

  const onSave = useCallback(() => {
    save(formState)
    history.push(`/admin/${routeName}`)
  }, [history, routeName, formState, save])

  return (
    <div>
      <h2>Details (#{item.id})</h2>
      <Form
        item={formState}
        onChange={setFormState}
        fields={fields}
        mode={FORM_MODES.EDIT}
      />
      <Button
        onClick={onSave}
        text="Save Changes"
        style={BUTTON_STYLES.PRIMARY}
      />
      <Button
        onClick={() => history.push(`/admin/${routeName}/delete/${item.id}`)}
        text="Delete"
        style={BUTTON_STYLES.DANGER}
      />
      <Button
        onClick={() => history.push(`/admin/${routeName}`)}
        text="Back to List"
      />
    </div>
  )
}

const Details = ({ apiUrl, routeName, fields }) => {
  const { id } = useParams()
  const [{ response: item, isLoading, error }, { save }] = useItem(apiUrl, id)

  if (isLoading)
    return (
      <div>
        <h2>Details</h2>
        <h3>Loading...</h3>
      </div>
    )
  if (error) return <div>{error}</div>
  if (item === null) return <Redirect to={`/admin/${routeName}`} />

  return (
    <DetailsBody
      item={item}
      save={save}
      routeName={routeName}
      fields={fields}
    />
  )
}

export default Details
